import { initProgressBar } from '../content/progress.js';
import { initCopyButtons } from '../content/copy-buttons.js';
import { initFigureLightbox } from '../content/lightbox.js';
import { initPaperDecks } from '../content/paper-deck.js';

initProgressBar();
initCopyButtons();
initFigureLightbox();
initPaperDecks();
